export default __webpack_public_path__ + "72b0bf2d50a14ee26875ecf67fc41d0c.png";